import { from } from 'rxjs'
import { switchMap, shareReplay, filter } from 'rxjs/operators'
import controllerLoadedObservableFactory from '@newswebsiteapp/shared/observables/controllerLoadedObservableFactory'

export const newsletterLoadedObservable =
  controllerLoadedObservableFactory('newsletters')

function waitIframe(iframeId) {
  return new Promise((resolve, reject) => {
    $(`#${iframeId}`).on('load', function () {
      resolve(this)
    })
  })
}

// wait for newsletter page loaded, then wait for iframe onload method called (only once)
export const newsletterIframeLoadedObservable = newsletterLoadedObservable.pipe(
  switchMap(() => from(waitIframe('preview_iframe'))),
  shareReplay(1), // without this body of switchMap will be called once for each subscriber
  filter((x) => x !== null),
)
